module.exports = __webpack_public_path__ + "static/img/food-policy012.7967a4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/food-policy012.png
// module id = K9/u
// module chunks = 1